module.exports = __webpack_public_path__ + "static/img/bg-function-6.c9588245.png";